module.exports = __webpack_public_path__ + "static/media/movie-ico.dd583933.svg";